import { put, takeLatest } from 'redux-saga/effects';
import { handleApiCall } from '../SagaUtils';
import { push } from 'react-router-redux';

import {
  FETCH_TEAMS,
  FETCH_TEAM,
  UPDATE_TEAM,
  CREATE_TEAM,
  DELETE_TEAM
} from '../../constants/Constants';
import * as Api from '../../services/Api';

function* fetchTeams({ payload: { pagination, filter, additionalQuery } }) {
  yield handleApiCall(FETCH_TEAMS, Api.fetchTeams, true, pagination, filter, additionalQuery);
}

function* fetchTeam({ payload: { teamId } }) {
  yield handleApiCall(FETCH_TEAM, Api.fetchTeam, true, teamId);
}

function* updateTeam({ payload: { data } }) {
  yield handleApiCall(UPDATE_TEAM, Api.updateTeam, true, data);
  yield put(push('/settings/teams'));
}

function* createTeam({ payload: { data } }) {
  yield handleApiCall(CREATE_TEAM, Api.createTeam, true, data);
  yield put(push('/settings/teams'));
}

function* deleteTeam({ payload: { teamId } }) {
  yield handleApiCall(DELETE_TEAM, Api.deleteTeam, true, teamId);
  yield put(push('/settings/teams'));
}

export default function* teamsSaga() {
  yield takeLatest(FETCH_TEAMS.REQUESTED, fetchTeams);
  yield takeLatest(FETCH_TEAM.REQUESTED, fetchTeam);
  yield takeLatest(UPDATE_TEAM.REQUESTED, updateTeam);
  yield takeLatest(CREATE_TEAM.REQUESTED, createTeam);
  yield takeLatest(DELETE_TEAM.REQUESTED, deleteTeam);
} 


// WEBPACK FOOTER //
// ./src/sagas/entities/TeamsSaga.js